import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Document, usePDF } from '@react-pdf/renderer';
import { Button, Icon } from 'rsuite';

const DownloadPdf = ({ content, fileName, label }) => {
  const ref = useRef();
  const [instance] = usePDF({
    document: <Document>{content}</Document>
  });
  const { loading = true, url = '' } = instance;

  useEffect(
    () => {
      if (!loading && url) ref.current.click();
    },
    [loading, url]
  );

  return (
    <a ref={ref} href={url} download={fileName}>
      <Button disabled={loading}>
        <Icon icon="print" /> {label}
      </Button>
    </a>
  );
};

DownloadPdf.propTypes = {
  content: PropTypes.node.isRequired,
  fileName: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired
};

export default DownloadPdf;
